// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment-dialog__action-btn {
    float: left;
    padding-right: 2rem;
    margin-left: 1rem;
}

.comment-dialog_window {
    border: 1px solid;
    width: 48rem;
    height: 45rem;
    text-align: center;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 2px 7px 1px rgb(0 0 0 / 75%);
    border-radius: 5px;
    z-index: 10;
}

.comment-dialog__toggle {
    background: none;
    border: none;
    box-shadow: none;
    padding: 0;
    margin: 0;
    text-transform: none;
    color: #039be5;
    font-size: 1.8rem;
    height: auto !important;
    line-height: 1.8rem !important;
    display: flex;
    letter-spacing: normal;
}

.comment-dialog__toggle:hover {
    background: none; 
    border: none; 
    box-shadow: none;
}

.comment-dialog__toggle:focus {
    background: none; 
}

.comment-container__name {
    margin: auto;
}

.comment-editor__input {
    width: 80%;
}

.send-comment__button{
    cursor: pointer;
}

#comment__textarea {
    font-size: initial;
}`, "",{"version":3,"sources":["webpack://./src/app/chat/comment-dialog/CommentDialog.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,oCAAoC;IACpC,4CAA4C;IAC5C,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".comment-dialog__action-btn {\r\n    float: left;\r\n    padding-right: 2rem;\r\n    margin-left: 1rem;\r\n}\r\n\r\n.comment-dialog_window {\r\n    border: 1px solid;\r\n    width: 48rem;\r\n    height: 45rem;\r\n    text-align: center;\r\n    background-color: rgb(255, 255, 255);\r\n    box-shadow: 0px 2px 7px 1px rgb(0 0 0 / 75%);\r\n    border-radius: 5px;\r\n    z-index: 10;\r\n}\r\n\r\n.comment-dialog__toggle {\r\n    background: none;\r\n    border: none;\r\n    box-shadow: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    text-transform: none;\r\n    color: #039be5;\r\n    font-size: 1.8rem;\r\n    height: auto !important;\r\n    line-height: 1.8rem !important;\r\n    display: flex;\r\n    letter-spacing: normal;\r\n}\r\n\r\n.comment-dialog__toggle:hover {\r\n    background: none; \r\n    border: none; \r\n    box-shadow: none;\r\n}\r\n\r\n.comment-dialog__toggle:focus {\r\n    background: none; \r\n}\r\n\r\n.comment-container__name {\r\n    margin: auto;\r\n}\r\n\r\n.comment-editor__input {\r\n    width: 80%;\r\n}\r\n\r\n.send-comment__button{\r\n    cursor: pointer;\r\n}\r\n\r\n#comment__textarea {\r\n    font-size: initial;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
